import { render } from "./YoutubePromoComponent.vue?vue&type=template&id=0e046682"
import script from "./YoutubePromoComponent.vue?vue&type=script&lang=js"
export * from "./YoutubePromoComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__